module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27058",
      "conversations-internal-schema": "static-1.12982",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8060",
      "hubspot-url-utils": "static-1.4173",
      "HubStyleTokens": "static-2.11518",
      "I18n": "static-7.1633",
      "jasmine-runner": "static-1.6509",
      "quartz": "static-1.7086",
      "react": "static-7.186",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.488",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6183",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3434",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18112",
      "cv-backend-services": "static-1.1555",
      "hub-http": "static-1.6267",
      "immutable": "static-2.80",
      "immutable-less": "static-1.4697",
      "quartz-config": "static-1.864",
      "quartz-core": "static-1.6305",
      "transmute": "static-2.85",
      "HeadJS": "static-2.765",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8020",
      "framer-motion": "static-1.72",
      "hs-test-utils-bend-plugin": "static-1.3171",
      "msw": "static-1.39",
      "react-redux": "static-7.72",
      "redux": "static-4.16",
      "testing-library": "static-1.152",
      "foundations-theming": "static-1.4463",
      "i18n-data": "static-1.222",
      "metrics-js": "static-1.9686",
      "moment-timezone": "static-5.83",
      "react-utils": "static-2.5379",
      "jasmine": "static-4.4370",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.66",
      "styled-components": "static-2.90",
      "UIComponents": "static-3.8464",
      "visitor-ui-component-library-icons": "static-1.5994",
      "bender-build-tools": "static-1.3227",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4696",
      "apollo-stack-hubspot": "static-3.86",
      "classnames": "static-2.10",
      "cssUtils": "static-1.801",
      "customer-data-objects": "static-1.7720",
      "customer-data-ui-utilities": "static-1.9870",
      "data-fetching-client": "static-1.9710",
      "FileManagerCore": "static-1.39242",
      "FileManagerLib": "static-1.39383",
      "foundations-assets": "static-1.4914",
      "graphql": "static-1.82",
      "hs-promise-utils": "static-1.5635",
      "hubspot-apollo-client": "static-1.4923",
      "icons": "static-2.650",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.105",
      "react-virtualized": "static-2.99",
      "rpc-client-utils": "static-1.4697",
      "salesImages": "static-1.526",
      "timezone-utils": "static-2.5288",
      "ui-gdpr-components": "static-1.10394",
      "ts-schema": "static-1.4115",
      "hs-locale-management": "static-1.116",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.137",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.839",
      "hubspotter-http": "static-1.4686",
      "mobile-manifest-mixins": "static-1.539",
      "module-federation": "static-1.23",
      "quartz-auth": "static-1.761",
      "quartz-head": "static-1.751",
      "quartz-i18n": "static-1.761",
      "quartz-routing": "static-1.516",
      "quartz-test": "static-1.761",
      "quartz-tracking": "static-1.465",
      "quick-fetch": "static-1.3952",
      "react-rhumb": "static-1.16720",
      "ui-fonts": "static-1.780",
      "usage-tracker-container": "static-1.7384",
      "usage-tracker-core": "static-1.7244",
      "bend-plugin-foundations-components": "static-1.4289",
      "floating-ui": "static-1.56",
      "foundations-theming-specialty": "static-1.2179",
      "hs-story-utils": "static-1.9468",
      "react-create-root-preference": "static-1.31",
      "tanstack-table": "static-1.55",
      "trellis-assets": "static-1.2058",
      "ui-images": "static-2.1163",
      "bend-plugin-foundations-theming": "static-1.2946",
      "foundations-theming-base": "static-1.3448",
      "stylex": "static-1.33",
      "HubStyle": "static-2.11825",
      "sassPrefix": "static-1.157",
      "inbound-db-properties-service-client": "static-1.3881",
      "property-translator": "static-1.5443",
      "react-dnd-compat": "static-1.4658",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9085",
      "audio-components": "static-1.5983",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29379",
      "file-manager-components": "static-1.23743",
      "FileManagerImages": "static-1.36894",
      "foundations-components-legacy": "static-1.1045",
      "immerable": "static-1.4198",
      "react-colorpicker": "static-2.10253",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.9032",
      "urlinator": "static-1.4583",
      "video-components": "static-1.13444",
      "video-data-lib": "static-1.35100",
      "video-embed": "static-1.35934",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.382",
      "bend-plugin-chirp-manifest": "static-1.107",
      "chirp-fetch": "static-1.1932",
      "hub-http-shared-msw-handlers": "static-1.10073",
      "hubspotter-http-shared-msw-handlers": "static-1.10071",
      "usage-tracker-session-replay": "static-1.5080",
      "web-vitals": "static-1.6",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21485",
      "ContentUtils": "static-1.68502",
      "copilot-toolkit": "static-1.11255",
      "customer-data-objects-ui-components": "static-1.13076",
      "sanitize": "static-1.4520",
      "sanitize-text": "static-1.8187",
      "content-assistance-lib": "static-1.7820",
      "usage-tracker": "static-1.7394",
      "ui-addon-iframeable": "static-1.9104",
      "video-components-external": "static-1.11442",
      "unified-auth-core-lib": "static-1.828",
      "content-icons-ui": "static-1.2236",
      "social-insights-client-types": "static-1.22230",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4221",
      "amplitude-session-replay-browser": "static-1.62",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4857",
      "integrations-lib": "static-1.16313",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.810",
      "magpie-lib": "static-1.5580",
      "magpie-types": "static-1.5040",
      "simple-logging-lib": "static-1.3096",
      "atom": "static-1.5119",
      "avatar-components": "static-1.2543",
      "reference-resolvers": "static-1.8216",
      "superstore": "static-1.4804",
      "ui-addon-video-player": "static-1.8748",
      "ui-coaching-tips": "static-1.28691",
      "navigation-messaging": "static-1.7482",
      "content-media-composition-data-lib": "static-1.12497",
      "content-media-compositions": "static-2.16504",
      "idb-keyval": "static-1.44",
      "media-bridge-lib": "static-1.19004",
      "fsm": "static-1.3775",
      "flux-actions": "static-1.341",
      "frontend-preferences-client": "static-1.7971",
      "integrations-error-boundary-lib": "static-1.13728",
      "integrations-tracking-lib": "static-1.5647",
      "laboratory-lib": "static-3.7200",
      "native-integrations-shared-strings": "static-1.7826",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10409",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11196",
      "ui-shepherd-react": "static-3.10245",
      "unified-auth": "static-1.546",
      "breeze-engine-core": "static-1.88",
      "ably": "static-2.2",
      "highlight.js": "static-1.79",
      "reactive-lib": "static-1.769",
      "growth-onboarding-feedback-components": "static-1.6624",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.3060",
      "foundations-components-test-utils": "static-1.5503",
      "google-sheets-integration-lib": "static-1.373",
      "microsoft-drive-integration-lib": "static-1.501",
      "slack-ui-library": "static-1.10436",
      "react-dlb": "static-1.79",
      "crm-record-cards-service-types": "static-1.3625",
      "framework-data-schema-resolvers": "static-1.6931",
      "location-customization-utils-lib": "static-1.9397",
      "batch-promise": "static-1.1587",
      "conditional-properties-service-client": "static-1.3833",
      "crm-pipelines-api-client-types": "static-1.4175",
      "fdsr-migration-layer": "static-1.50",
      "framework-builder-read-service-client": "static-1.4040",
      "framework-data-schema-quick-fetch": "static-1.6836",
      "inbound-db-meta-service-client": "static-1.3621",
      "multi-currency-client-types": "static-1.3727",
      "persist-promise": "static-1.3744"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27058",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12982",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8060",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4173",
      "HubStyleTokens": "/HubStyleTokens/static-2.11518",
      "I18n": "/I18n/static-7.1633",
      "jasmine-runner": "/jasmine-runner/static-1.6509",
      "quartz": "/quartz/static-1.7086",
      "react": "/react/static-7.186",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.488",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6183",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3434",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18112",
      "cv-backend-services": "/cv-backend-services/static-1.1555",
      "hub-http": "/hub-http/static-1.6267",
      "immutable": "/immutable/static-2.80",
      "immutable-less": "/immutable-less/static-1.4697",
      "quartz-config": "/quartz-config/static-1.864",
      "quartz-core": "/quartz-core/static-1.6305",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.765",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8020",
      "framer-motion": "/framer-motion/static-1.72",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3171",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.72",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.152",
      "foundations-theming": "/foundations-theming/static-1.4463",
      "i18n-data": "/i18n-data/static-1.222",
      "metrics-js": "/metrics-js/static-1.9686",
      "moment-timezone": "/moment-timezone/static-5.83",
      "react-utils": "/react-utils/static-2.5379",
      "jasmine": "/jasmine/static-4.4370",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.66",
      "styled-components": "/styled-components/static-2.90",
      "UIComponents": "/UIComponents/static-3.8464",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5994",
      "bender-build-tools": "/bender-build-tools/static-1.3227",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4696",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.801",
      "customer-data-objects": "/customer-data-objects/static-1.7720",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9870",
      "data-fetching-client": "/data-fetching-client/static-1.9710",
      "FileManagerCore": "/FileManagerCore/static-1.39242",
      "FileManagerLib": "/FileManagerLib/static-1.39383",
      "foundations-assets": "/foundations-assets/static-1.4914",
      "graphql": "/graphql/static-1.82",
      "hs-promise-utils": "/hs-promise-utils/static-1.5635",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4923",
      "icons": "/icons/static-2.650",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.105",
      "react-virtualized": "/react-virtualized/static-2.99",
      "rpc-client-utils": "/rpc-client-utils/static-1.4697",
      "salesImages": "/salesImages/static-1.526",
      "timezone-utils": "/timezone-utils/static-2.5288",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10394",
      "ts-schema": "/ts-schema/static-1.4115",
      "hs-locale-management": "/hs-locale-management/static-1.116",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.137",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.839",
      "hubspotter-http": "/hubspotter-http/static-1.4686",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
      "module-federation": "/module-federation/static-1.23",
      "quartz-auth": "/quartz-auth/static-1.761",
      "quartz-head": "/quartz-head/static-1.751",
      "quartz-i18n": "/quartz-i18n/static-1.761",
      "quartz-routing": "/quartz-routing/static-1.516",
      "quartz-test": "/quartz-test/static-1.761",
      "quartz-tracking": "/quartz-tracking/static-1.465",
      "quick-fetch": "/quick-fetch/static-1.3952",
      "react-rhumb": "/react-rhumb/static-1.16720",
      "ui-fonts": "/ui-fonts/static-1.780",
      "usage-tracker-container": "/usage-tracker-container/static-1.7384",
      "usage-tracker-core": "/usage-tracker-core/static-1.7244",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4289",
      "floating-ui": "/floating-ui/static-1.56",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2179",
      "hs-story-utils": "/hs-story-utils/static-1.9468",
      "react-create-root-preference": "/react-create-root-preference/static-1.31",
      "tanstack-table": "/tanstack-table/static-1.55",
      "trellis-assets": "/trellis-assets/static-1.2058",
      "ui-images": "/ui-images/static-2.1163",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2946",
      "foundations-theming-base": "/foundations-theming-base/static-1.3448",
      "stylex": "/stylex/static-1.33",
      "HubStyle": "/HubStyle/static-2.11825",
      "sassPrefix": "/sassPrefix/static-1.157",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3881",
      "property-translator": "/property-translator/static-1.5443",
      "react-dnd-compat": "/react-dnd-compat/static-1.4658",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9085",
      "audio-components": "/audio-components/static-1.5983",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29379",
      "file-manager-components": "/file-manager-components/static-1.23743",
      "FileManagerImages": "/FileManagerImages/static-1.36894",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1045",
      "immerable": "/immerable/static-1.4198",
      "react-colorpicker": "/react-colorpicker/static-2.10253",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.9032",
      "urlinator": "/urlinator/static-1.4583",
      "video-components": "/video-components/static-1.13444",
      "video-data-lib": "/video-data-lib/static-1.35100",
      "video-embed": "/video-embed/static-1.35934",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.382",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.107",
      "chirp-fetch": "/chirp-fetch/static-1.1932",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10073",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10071",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5080",
      "web-vitals": "/web-vitals/static-1.6",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21485",
      "ContentUtils": "/ContentUtils/static-1.68502",
      "copilot-toolkit": "/copilot-toolkit/static-1.11255",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13076",
      "sanitize": "/sanitize/static-1.4520",
      "sanitize-text": "/sanitize-text/static-1.8187",
      "content-assistance-lib": "/content-assistance-lib/static-1.7820",
      "usage-tracker": "/usage-tracker/static-1.7394",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9104",
      "video-components-external": "/video-components-external/static-1.11442",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.828",
      "content-icons-ui": "/content-icons-ui/static-1.2236",
      "social-insights-client-types": "/social-insights-client-types/static-1.22230",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4221",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.62",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4857",
      "integrations-lib": "/integrations-lib/static-1.16313",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.810",
      "magpie-lib": "/magpie-lib/static-1.5580",
      "magpie-types": "/magpie-types/static-1.5040",
      "simple-logging-lib": "/simple-logging-lib/static-1.3096",
      "atom": "/atom/static-1.5119",
      "avatar-components": "/avatar-components/static-1.2543",
      "reference-resolvers": "/reference-resolvers/static-1.8216",
      "superstore": "/superstore/static-1.4804",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8748",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28691",
      "navigation-messaging": "/navigation-messaging/static-1.7482",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12497",
      "content-media-compositions": "/content-media-compositions/static-2.16504",
      "idb-keyval": "/idb-keyval/static-1.44",
      "media-bridge-lib": "/media-bridge-lib/static-1.19004",
      "fsm": "/fsm/static-1.3775",
      "flux-actions": "/flux-actions/static-1.341",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7971",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13728",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5647",
      "laboratory-lib": "/laboratory-lib/static-3.7200",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7826",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10409",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11196",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10245",
      "unified-auth": "/unified-auth/static-1.546",
      "breeze-engine-core": "/breeze-engine-core/static-1.88",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.79",
      "reactive-lib": "/reactive-lib/static-1.769",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6624",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3060",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5503",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.373",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.501",
      "slack-ui-library": "/slack-ui-library/static-1.10436",
      "react-dlb": "/react-dlb/static-1.79",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3625",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6931",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9397",
      "batch-promise": "/batch-promise/static-1.1587",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3833",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4175",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.50",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4040",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6836",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3621",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3727",
      "persist-promise": "/persist-promise/static-1.3744"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27058",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};